export const CHUNK_ERROR_DECISION = Object.freeze({
	IGNORE: 'IGNORE',
	ALREADY_HANDLED: 'ALREADY_HANDLED',
	START_HANDLING: 'START_HANDLING',
})

export const isChunkRelatedError = error => {
	if (!error) return false

	const chunkFailedMessage = /Loading chunk \d+ failed/
	const cssChunkFailedMessage = /Loading CSS chunk \d+ failed/
	const chunkFailedMessageChinese = /載入 chunk \d+ 失敗/
	const syntaxErrorFromChunk = /Unexpected token '<'/
	const chunkFilePattern = /\d+\.[a-f0-9]+\.(js|css)/

	const message = error.message || ''

	// 檢查是否為 chunk 相關的語法錯誤（通常是 404 返回 HTML 導致）
	const isChunkSyntaxError =
		error.name === 'SyntaxError' &&
		syntaxErrorFromChunk.test(message) &&
		(error.fileName || error.stack || '').match(chunkFilePattern)

	return (
		error.name === 'ChunkLoadError' ||
		chunkFailedMessage.test(message) ||
		cssChunkFailedMessage.test(message) ||
		chunkFailedMessageChinese.test(message) ||
		isChunkSyntaxError
	)
}

export const getChunkErrorHandlingDecision = (
	error,
	{ isHandlingChunkError = false, permanentlyExhausted = false } = {},
) => {
	if (!isChunkRelatedError(error)) {
		return CHUNK_ERROR_DECISION.IGNORE
	}
	if (permanentlyExhausted || isHandlingChunkError) {
		return CHUNK_ERROR_DECISION.ALREADY_HANDLED
	}
	return CHUNK_ERROR_DECISION.START_HANDLING
}
